import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Description from "../../../components/ui/Description";
import TitleStyles from "../../../components/ui/TitleStyles";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import TooltipModal from "../../../components/tooltipModal/TooltipModal";
import PhotoUploadGroup from "../../../components/photoUploadGroup/PhotoUploadGroup";
import DraggableSectionList from "../../../components/draggableSectionList/DraggableSectionList";
import { Container, Position } from "./EdityStyles";
import { SectionData } from "../../../types/componentsConstructors";

const Edit = () => {
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(true);

  const [sections, setSections] = useState<SectionData[]>([
    {
      id: "artistName",
      title: "Nome artístico",
      type: "text",
      value: "DJ Matheus",
    },
    {
      id: "phrase",
      title: "Frase",
      type: "textarea",
      value: "Criando experiências únicas através da música.",
    },
    {
      id: "bio",
      title: "Biografia",
      type: "textarea",
      value: "DJ Matheus é um artista apaixonado pela música eletrônica...",
    },
    {
      id: "musics",
      title: "Música e set",
      type: "multiLink",
      value: [
        { name: "Kiss", url: "https://soundcloud.com/kiss" },
        { name: "Work It", url: "https://youtube.com/work-it" },
      ],
    },
    {
      id: "events",
      title: "Eventos",
      type: "multiLink",
      value: [
        {
          name: "Só Track Boa - 07/06/2025",
          url: "https://instagram.com/sotrackboa",
        },
      ],
    },
    {
      id: "Vídeo",
      title: "Vídeo YouTube",
      type: "link",
      value: "https://www.youtube.com/@video",
    },
    {
      id: "spotify",
      title: "Spotify",
      type: "link",
      value: "https://open.spotify.com/artist/example",
    },
    {
      id: "soundcloud",
      title: "SoundCloud",
      type: "link",
      value: "https://soundcloud.com/seuusuario",
    },
    {
      id: "instagram",
      title: "Instagram",
      type: "link",
      value: "https://instagram.com/iubl.wav",
    },
    {
      id: "youtube",
      title: "YouTube",
      type: "link",
      value: "https://www.youtube.com/@seucanal",
    },
    {
      id: "whatsapp",
      title: "WhatsApp",
      type: "link",
      value: "https://wa.me/558899999999",
    },
    {
      id: "photos",
      title: "Fotos secundárias",
      type: "imageGroup",
      value: "",
    },
  ]);

  const handleChange = (id: string, newValue: any) => {
    const updatedSections = sections.map((section) =>
      section.id === id ? { ...section, value: newValue } : section
    );
    setSections(updatedSections);
  };

  const handleDelete = (id: string) => {
    setSections((prev) =>
      prev.map((section) =>
        section.id === id
          ? {
              ...section,
              value: section.type === "multiLink" ? [] : "",
            }
          : section
      )
    );
  };

  return (
    <Container>
      {showTooltip && (
        <TooltipModal
          onClose={() => setShowTooltip(false)}
          buttonLabel="Começar!"
        >
          <p>
            <strong>Organize e Edite Seu Layout!</strong>
            <br />
            Você pode personalizar a ordem das seções arrastando e soltando.
            Clique em editar para ajustar os textos, ou em apagar para esconder.
          </p>
        </TooltipModal>
      )}

      <TitleStyles>Editar</TitleStyles>
      <Description>Aproveite para editar seu layout</Description>

      <DraggableSectionList
        sections={sections.filter((s) => s.type !== "imageGroup")}
        setSections={(newList) => {
          const photos = sections.find((s) => s.type === "imageGroup");
          const updated = photos ? [...newList, photos] : newList;
          setSections(updated);
        }}
        onDelete={handleDelete}
        onChange={handleChange}
      />

      <PhotoUploadGroup />

      <Position>
        <ProgressBar totalSteps={9} currentStep={7} />
        <ButtonGroup
          onBack={() => navigate("/social-media")}
          onNext={() => navigate("/url")}
          nextLabel="Salvar >"
        />
      </Position>
    </Container>
  );
};

export default Edit;
